$('.product-categories .cat-parent').each(function () {
    let $children = $(this).find('.children');
    let $dropdown = $('<button class="cat-children-toggle btn--color-white"></button>');
    $dropdown.click(function () {
        $(this).toggleClass('active');
        $children.slideToggle();
    });
    $children.before($dropdown);
});
